import Branding from '@components/branding/branding';

const BrandingComponent = () => {
  return <Branding />;
};

export default BrandingComponent;
